import { ReplayHighlight } from "src/features/events/model/replay-highlight";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchHighligtedProduct } from "./highligtedProductApi";
import { HighlightedProduct } from "./model/HighlightedProduct";
import replayHighightedProductFromCurrentTime from "./util/replay-highlighted-product-from-current-time";
import isEmpty from "src/shared/util/is-empty";
import { RootState } from "src/shared/store";
import { fetchReplayHighlights } from "../events/eventsApi";

let store: any;
export const injectStore = (_store: any) => {
  store = _store;
};

export interface HighlightedProductState {
  item: HighlightedProduct[];
  status: "pending" | "fulfilled" | "rejected";
  replayHighlightData: ReplayHighlight[];
}

const initialState: HighlightedProductState = {
  item: [],
  replayHighlightData: [],
  status: "pending",
};

export const highlightedProductSlice = createSlice({
  name: "highlightedProduct",
  initialState,
  reducers: {
    reset: (state) => {
      state.item = [];
    },
    setReplayHighlightData: (state, action) => {
      state.replayHighlightData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetch.fulfilled, (state, action) => {
        state.status = "fulfilled";
        const { data, status: responseStatus } = action.payload;
        if (responseStatus === 404 || responseStatus === 429) {
          state.item = [];
        } else if (responseStatus === 502) {
          // do nothing
        } else {
          state.item = data;
        }
      })
      .addCase(fetch.rejected, (state, action) => {
        state.status = "rejected";
      })
      .addCase(replayFetch.fulfilled, (state, action) => {
        state.status = "fulfilled";
        if (!isEmpty(action.payload)) {
          state.item = action.payload;
        } else {
          state.item = [];
        }
      });
  },
});

export const { reset, setReplayHighlightData } =
  highlightedProductSlice.actions;

export const fetch = createAsyncThunk(
  "products/fetchHighligtedProduct",
  async () => {
    try {
      const response: any = await fetchHighligtedProduct();
      return response;
    } catch (e) {
      throw e;
    }
  }
);

export const replayFetch = createAsyncThunk(
  "products/replayFetchHighligtedProduct",
  async (_, { dispatch }) => {
    try {
      const currentTime = store.getState().video.READONLY_currentTime;
      const { data: replayHighlightedProductList } =
        (await fetchReplayHighlights()) || {};

      // TODO REMOVE !!! Manually adjusting delay
      const manualDelayReplayProductList = replayHighlightedProductList.map(
        (event: any) => {
          const _newEvent = event;
          _newEvent.timestamp -= 26;
          return _newEvent;
        }
      );

      dispatch(setReplayHighlightData(manualDelayReplayProductList));

      const replayHighlightedProduct = replayHighightedProductFromCurrentTime(
        currentTime,
        replayHighlightedProductList
      );

      return replayHighlightedProduct;
    } catch (e) {
      throw e;
    }
  }
);

export const dataSelector = (state: RootState) => state.highlightedProduct.item;
export const statusSelector = (state: RootState) =>
  state.highlightedProduct.status;
export const replayHighlightDataSelector = (state: RootState) =>
  state.highlightedProduct.replayHighlightData;

export const fetchOptions = {
  fetch,
  dataSelector,
  statusSelector,
};

export const replayFetchOptions = {
  fetch: replayFetch,
  dataSelector: dataSelector,
  statusSelector,
};

export default highlightedProductSlice.reducer;
